import CleanRedisStore from './clean-redis-store.vue';
import LocaleCategories from './locale-categories.vue';
import LocaleCopy from './locale-copy.vue';
import LocaleDeduplicateFoods from './locale-deduplicate-foods.vue';
import LocaleFoodNutrientAssociation from './locale-food-nutrient-association.vue';
import LocaleFoodNutrientMapping from './locale-food-nutrient-mapping.vue';
import LocaleFoodRankingUpload from './locale-food-ranking-upload.vue';
import LocaleFoods from './locale-foods.vue';
import LocaleIndexBuild from './locale-index-build.vue';
import LocalesSync from './locales-sync.vue';
import NutrientTableDataImport from './nutrient-table-data-import.vue';
import NutrientTableMappingExport from './nutrient-table-mapping-export.vue';
import NutrientTableMappingImport from './nutrient-table-mapping-import.vue';
import ResourceExport from './resource-export.vue';
import SurveyAuthUrlsExport from './survey-auth-urls-export.vue';
import SurveyDataExport from './survey-data-export.vue';
import SurveyEventNotification from './survey-event-notification.vue';
import SurveyNutrientsRecalculation from './survey-nutrients-recalculation.vue';
import SurveyRatingsExport from './survey-ratings-export.vue';
import SurveyRespondentsImport from './survey-respondents-import.vue';
import SurveySessionsExport from './survey-sessions-export.vue';

export default {
  CleanRedisStore,
  LocaleDeduplicateFoods,
  LocaleFoodNutrientAssociation,
  LocaleFoodNutrientMapping,
  LocaleFoodRankingUpload,
  LocaleCategories,
  LocaleCopy,
  LocaleFoods,
  LocaleIndexBuild,
  LocalesSync,
  NutrientTableDataExport: NutrientTableMappingExport,
  NutrientTableDataImport,
  NutrientTableMappingExport,
  NutrientTableMappingImport,
  ResourceExport,
  SurveyAuthUrlsExport,
  SurveyDataExport,
  SurveyEventNotification,
  SurveyNutrientsRecalculation,
  SurveyRatingsExport,
  SurveyRespondentsImport,
  SurveySessionsExport,
};
